import React from 'react';
import { ChevronDown, ChevronUp, FileText } from 'lucide-react';
import Select from '../../../components/ui/Select';

const IncidentDescription = ({ expanded, onToggle, formData, setFormData }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <FileText className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">
            Incident Description <span className="text-red-600">*</span>
          </h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Detailed Description <span className="text-red-600">*</span>
              </label>
              <textarea
                value={formData?.description}
                onChange={(e) => setFormData(prev => ({ ...prev, description: e?.target?.value }))}
                rows={6}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Provide a detailed description of what happened, including sequence of events, conditions present, and any contributing factors..."
                required
              />
              <p className="mt-1 text-xs text-gray-500">
                Be as specific as possible. Include what was happening before, during, and after the incident.
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Preliminary Root Cause Assessment
              </label>
              <Select
                value={formData?.rootCause}
                onChange={(e) => setFormData(prev => ({ ...prev, rootCause: e?.target?.value }))}
              >
                <option value="">Select preliminary cause</option>
                <option value="Equipment Failure">Equipment Failure</option>
                <option value="Human Error">Human Error</option>
                <option value="Procedural Violation">Procedural Violation</option>
                <option value="Inadequate Training">Inadequate Training</option>
                <option value="Environmental Conditions">Environmental Conditions</option>
                <option value="Communication Breakdown">Communication Breakdown</option>
                <option value="Inadequate PPE">Inadequate PPE</option>
                <option value="Other">Other</option>
              </Select>
              <p className="mt-1 text-xs text-gray-500">
                This is a preliminary assessment. Detailed root cause analysis will be conducted during investigation.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IncidentDescription;